// extracted by mini-css-extract-plugin
export default {"no-access":"NoAccess_no-access__mw4jg"};